var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "classnames", "../../UI/Icon/Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("classnames"), require("../../UI/Icon/Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.classnames, global.Icon);
    global.ProgramInfos = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _classnames, _Icon) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _Icon = _interopRequireDefault(_Icon);

  var ProgramInfosIcon = function ProgramInfosIcon(theme) {
    return function (_ref) {
      var icon = _ref.icon,
          title = _ref.title;
      return /*#__PURE__*/_react.default.createElement(_Icon.default, {
        key: icon,
        className: "metas-infos__icon",
        title: title,
        name: icon,
        color: theme === 'presse' ? 'black' : 'grey',
        colorTone: theme !== 'presse' ? 'dark' : null,
        size: "custom"
      });
    };
  };

  ProgramInfosIcon.propTypes = {
    icon: _propTypes.default.string.isRequired,
    title: _propTypes.default.string.isRequired
  };

  var ProgramInfos = function ProgramInfos(_ref2) {
    var theme = _ref2.theme,
        availability = _ref2.availability,
        className = _ref2.className,
        durationLabel = _ref2.durationLabel,
        icons = _ref2.icons,
        labels = _ref2.labels,
        lastDay = _ref2.lastDay,
        nextBroadcast = _ref2.nextBroadcast;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('metas-infos', theme, className)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('metas-infos__title', theme, className)
    }, durationLabel), availability !== null && /*#__PURE__*/_react.default.createElement("div", {
      className: "metas-infos__availability"
    }, labels.availability, availability, lastDay && /*#__PURE__*/_react.default.createElement("span", {
      className: "metas-info__last-day"
    }, " ", labels.lastDay)), nextBroadcast && /*#__PURE__*/_react.default.createElement("div", {
      className: "metas-infos__next-broadcast"
    }, labels.nextBroadcast, nextBroadcast), icons.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "metas-infos__flex"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "metas-infos__icons"
    }, icons.map(function (icon) {
      return ProgramInfosIcon(theme)(icon);
    }))));
  };

  ProgramInfos.propTypes = {
    availability: _propTypes.default.string,
    className: _propTypes.default.string,
    durationLabel: _propTypes.default.string.isRequired,
    icons: _propTypes.default.arrayOf(_propTypes.default.shape({
      title: _propTypes.default.string.isRequired,
      icon: _propTypes.default.string.isRequired
    })),
    labels: _propTypes.default.shape({
      availability: _propTypes.default.string.isRequired,
      nextBroadcast: _propTypes.default.string.isRequired,
      lastDay: _propTypes.default.string
    }).isRequired,
    lastDay: _propTypes.default.bool,
    nextBroadcast: _propTypes.default.string,
    theme: _propTypes.default.string
  };
  ProgramInfos.defaultProps = {
    availability: '',
    className: '',
    durationLabel: '',
    icons: [],
    labels: {
      availability: 'Disponible : ',
      nextBroadcast: 'Prochaine diffusion : ',
      lastDay: 'Dernier jour'
    },
    lastDay: false,
    nextBroadcast: '',
    trackingEnabled: false
  };
  var _default = ProgramInfos;
  _exports.default = _default;
});